import { buildTypes } from 'utils/reducer-utils';
import store from 'app-store';
import Person from 'services/data/person';
import { useQuery, useQueryClient } from 'react-query';

const { SET } = buildTypes('people');

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}

export function usePeople(queryOptions = {}, params = {}) {
  const key = ['person', params.where];
  
  params.load = params.load || ['primaryEmail', 'phoneNumbers'];

  const queryClient = useQueryClient();
  const queryData = useQuery(key, () => Person.find(params), queryOptions);

  return { ...queryData, refetch: () => queryClient.refetchQueries(key) };
}

export function usePerson(id, queryOptions = {}, params = {}) {
  const key = ['person', id];
  params.load = params.load || ['primaryEmail', 'phoneNumbers'];

  const queryClient = useQueryClient();
  const queryData = useQuery(key, () => Person.findOne(id, params), queryOptions);

  return { ...queryData, refetch: () => queryClient.refetchQueries(key) };
}
